import React, { useState } from "react";
import logoPilari from "../assets/images/pilari_light.png";
import logoGZW from "../assets/images/gzw.png";
import { Smartphone } from "lucide-react";
import api from "../services/ApiService";
import { useTranslation } from "react-i18next";

const DownloadPage = () => {
  const installLink = "https://play.google.com/apps/testing/com.jawaxa.pilari";
  const { t } = useTranslation();

  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const isEmailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleAccessRequest = async () => {
    if (!email.endsWith("@gmail.com")) {
      alert(t("download.onlyGmail"));
      return;
    }

    setLoading(true);

    try {
      const response = await api.post("/early-access", { email });
      const msg = response.data.message;

      setSubmitted(true);

      if (msg === "Email sudah terdaftar.") {
        alert(t("download.alreadyRegistered"));
      } else if (response.status === 201) {
        alert(t("download.success"));
        window.open(installLink, "_blank");
      } else {
        alert(msg || t("download.errorSaving"));
      }
    } catch (err) {
      console.error("Gagal submit email:", err);
      alert(t("download.submitError"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 dark:bg-gray-900 text-gray-800 dark:text-gray-100 transition-colors duration-300 py-24 px-4 font-sans">
      <div className="max-w-3xl mx-auto bg-white dark:bg-gray-800 rounded-3xl shadow-xl overflow-hidden transition-colors duration-300">

        {/* Hero Section */}
        <div className="relative h-[320px] sm:h-[400px]">
          <img
            src={require("../assets/images/cikuray.webp")}
            alt="Gunung Cikuray"
            className="absolute inset-0 w-full h-full object-cover brightness-75"
          />
          <div className="absolute inset-0 flex flex-col items-center justify-center text-white text-center px-6">
            <img
              src={logoPilari}
              alt="Logo Pilari"
              className="w-20 sm:w-24 mb-3 drop-shadow-md"
            />
            <h1 className="text-3xl sm:text-4xl font-bold drop-shadow-lg">
              {t("download.title")}
            </h1>
            <p className="text-sm sm:text-base font-medium drop-shadow-sm mt-2">
              {t("download.subtitle")}
            </p>
          </div>
        </div>

        {/* Main Form Content */}
        <div className="p-8 space-y-6 text-sm sm:text-base text-gray-700 dark:text-gray-200 text-center">
          <p>{t("download.desc1")}</p>
          <p className="text-gray-600 dark:text-gray-400">{t("download.desc2")}</p>

          <div className="flex flex-col items-center gap-4 w-full">
            <input
              type="email"
              placeholder={t("download.placeholder")}
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setSubmitted(false);
              }}
              className="w-full max-w-sm border rounded-lg px-4 py-2 text-sm text-gray-700 dark:text-gray-100 dark:bg-gray-700 dark:border-gray-600 focus:outline-none focus:ring-2 focus:ring-green-500"
              required
            />

            <button
              onClick={handleAccessRequest}
              disabled={!isEmailValid || loading}
              className={`w-full max-w-sm inline-flex items-center justify-center gap-2 px-6 py-3 rounded-lg shadow transition ${
                isEmailValid && !loading
                  ? "bg-green-700 text-white hover:bg-green-800"
                  : "bg-gray-300 text-gray-500 dark:bg-gray-700 dark:text-gray-400 cursor-not-allowed"
              }`}
            >
              {loading ? (
                <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
              ) : (
                <>
                  <Smartphone className="w-4 h-4" />
                  {t("download.button")}
                </>
              )}
            </button>
          </div>

          {submitted && (
            <p className="text-green-600 dark:text-green-400 text-sm mt-2">
              ✅ {t("download.status")}
            </p>
          )}
          <p className="text-xs text-gray-500 dark:text-gray-400">{t("download.infoNote")}</p>
        </div>

        {/* Footer Section */}
        <footer className="bg-gray-50 dark:bg-gray-900 border-t border-gray-200 dark:border-gray-700 text-center py-4">
          <div className="inline-flex items-center justify-center gap-2 text-xs text-gray-500 dark:text-gray-400">
            <span>{t("download.poweredBy")}</span>
            <img src={logoGZW} alt="Garut Zero Waste" className="h-8" />
          </div>
        </footer>
      </div>
    </div>
  );
};

export default DownloadPage;
